import React, { useEffect, useState } from "react";
import { FaSun, FaMoon } from "react-icons/fa";

function ThemeToggle() {
  const [dark, setDark] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === "dark") return true;
    if (savedTheme === "light") return false;
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  useEffect(() => {
    if (dark) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [dark]);

  return (
    <button
      type="button"
      onClick={() => setDark(!dark)}
      className="p-2 rounded-lg border border-white/25 bg-white/10 text-white hover:bg-white/20 transition-colors shrink-0"
      aria-label={dark ? "Switch to light theme" : "Switch to dark theme"}
    >
      {dark ? <FaSun className="text-amber-200" /> : <FaMoon className="text-orange-100" />}
    </button>
  );
}

export default ThemeToggle;
